module.exports = __webpack_public_path__ + "img/article.94999c17.svg";